import { LoginForm } from "@/pages/Auth/components/login-form";

export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted dark:bg-background px-4">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-semibold tracking-tight text-foreground mb-2">
            Admin Portal
          </h1>
          <p className="text-muted-foreground">Sign in to access the dashboard</p>
        </div>
        <LoginForm />
      </div>
    </div>
  );
}
